import { styled, StyledText } from '@clickcease/cc-client-components-lib'
import i18n from 'Lib/i18n'

export const styleReset = { marginRight: '0px', marginLeft: '0px' }

export const ModalBody = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  color: '$black',
})

export const ModalDescription = styled(StyledText, {
  display: 'block',
  marginBottom: '$8',
  defaultVariants: {
    variant: 'baseRegular',
  },
})

export const Label = styled('label', {
  fontSize: '$md',
  fontWeight: '$sb',
  marginBottom: '$6',
  '&:not(:first-of-type)': {
    marginTop: '$12',
  },
  variants: {
    error: {
      true: {
        color: '$error',
      },
    },
  },
})

export const RequiredText = styled('span', {
  fontWeight: '$l',
  fontSize: '$sm',

  variants: {
    error: {
      true: {
        color: '$error',
      },
    },
  },
})

export const ContactSupport = styled('p', {
  marginTop: '$5',
  fontWeight: '$l',
  fontSize: '$md',
  marginBottom: '$0',
})

export const StyledLink = styled('a', {
  all: 'unset',
  fontWeight: '$l',
  fontSize: '$md',
  color: '$primaryColor',
  cursor: 'pointer',
  marginLeft: '$2',
  marginRight: '$2',
})

export const BoldText = styled('span', {
  fontWeight: '$sb',
})

export const ToastContainer = styled('div', {
  marginTop: '$6',
  width: '100%',
  '& > div': {
    width: '-webkit-fill-available',
    ':first-child': {
      display: 'flex',
    },
  },
})

export const cssHover = {
  position: 'relative',
  ':has(button:disabled):hover:after': {
    content: `${i18n.t('plan_details.reason_modal.platforms.cant_cancel_product_while_trial', {
      ns: 'accountSettings',
    })}`,
    position: 'absolute',
    display: 'block',
    bottom: '100%',
    left: 0,
    width: '350px',
    height: 'auto',
    maxWidth: '90%',
    color: '$black',
    padding: '$4 $6',
    fontSize: '$sm',
    backgroundColor: '$white',
    border: '1px solid $lightGray',
    borderRadius: '$normal',
  },
}

export const ToastWrapper = styled('div', {
  marginBottom: '15px',
})
